import { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export default function PlayerMenuContentTitle({ children, className, ...props }: Props) {
  return (
    <div className={cn("text-18 font-black uppercase", className)} {...props}>
      {children}
    </div>
  );
}
